import MenuLink from '../link/MenuLink';
import { Menu as MenuType } from './types';

interface Props {
  menu: MenuType;
  styles?: string;
}

export const WarnMenu = ({ menu, styles }: Props) => {
  return (
    <div
      className={`bg-ffbb-white-opacity-30 dropdown dropdown-hover ml-5 flex h-full items-center`}
    >
      <div
        className={`inline-flex h-full items-center justify-center gap-1.5 rounded-lg px-5 ${styles}`}
      >
        <MenuLink
          {...menu}
          prefetch={false}
          type={'top'}
          hoverMainMenuEffect={false}
          hoverTopMenuEffect={false}
          styles="flex items-center text-white transition-colors duration-200 group-hover:text-white h-full text-sm font-bold"
        />
      </div>
    </div>
  );
};
